import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelButtonLabel: {
    id: 'frontbucket.branches.deleteSelectedBranches.cancelButtonLabel',
    description: 'Button label for cancelling delete branches',
    defaultMessage: 'Cancel',
  },
  deleteButtonLabel: {
    id: 'frontbucket.branches.deleteSelectedBranches.deleteButtonLabel',
    description: 'Button label for deleting selected branches',
    defaultMessage: 'Delete selected branches',
  },
  selectedBranchesCountLabel: {
    id: 'frontbucket.branches.deleteSelectedBranches.selectedBranchesCountLabel',
    description:
      'Label displays the count of selected branches in the current page',
    defaultMessage:
      '<b>{count, plural, one {{count} branch} other {{count} branches}}</b> selected in total.',
  },
});
